import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'

export class EndlessSlider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-endless-slider')
    if (!this.sliders) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.swiper.autoplay.start()
          } else {
            entry.target.swiper.autoplay.stop()
          }
        })
      },
      { root: null, threshold: 0, rootMargin: `0px 0px` }
    )

    window.addEventListener('load', () => {
      this.initSwiper()
    })
  }
  initSwiper() {
    this.sliders.forEach((slider) => {
      const option = {
        speed: slider.getAttribute('data-speed') || 30000,
        autoplayDirection: slider.classList.contains('-reverse') || false,
      }

      this.cloneSlide(slider)

      const swiper = new Swiper(slider, {
        modules: [Autoplay],
        autoplay: {
          delay: 0,
          reverseDirection: option.autoplayDirection,
        },
        loop: true,
        speed: option.speed,
        slidesPerView: 'auto',
        allowTouchMove: false,
      })

      this.observer.observe(swiper.el)
    })
  }

  cloneSlide(slider) {
    const slides = slider.querySelectorAll('.swiper-slide')
    slides.forEach(function (slide) {
      const cloneSlide = slide.cloneNode(true)
      slider.querySelector('.swiper-wrapper').appendChild(cloneSlide)
    })
  }
}
